import { Icon } from '@statsbomb/kitbag-components';
import { UserConfigFilterDefinition } from '@statsbomb/parachute-types';
import { Trans, useTranslation } from 'react-i18next';
import { DATA_LOCKER_LANDING_PAGE_TAB } from '@/consts/searchKeys';
import { useUrlLocale } from '@/hooks/useUrlLocale';
import { DataLockerSelectedTab } from '@/types/tabs';
import { filterSetQueryParams } from '@/utils/filters';
import { QuickStartCard } from './QuickStartCard';

// Resumes the user's latest saved search, the same query string useNavigateToFilterSetId builds; with none to resume
// it opens Player Scout's landing page instead.
export const PlayerScoutCard = ({ savedSearch }: { savedSearch: UserConfigFilterDefinition | undefined }) => {
  const { t } = useTranslation('home');
  const locale = useUrlLocale();

  if (!savedSearch) {
    return (
      <QuickStartCard
        avatar={<Icon variant="PlayerSoccer" />}
        title={t('quickStart.savedSearchTitle')}
        description={<Trans t={t} i18nKey="quickStart.playerScout" components={{ bold: <strong /> }} />}
        to={`/${locale}/data-locker?${DATA_LOCKER_LANDING_PAGE_TAB}=${DataLockerSelectedTab.PLAYER}`}
      />
    );
  }

  const searchParams = new URLSearchParams(
    filterSetQueryParams(savedSearch.configId, savedSearch.definition.filters.metric).map(({ key, value }) => [
      key,
      value,
    ]),
  );

  return (
    <QuickStartCard
      avatar={<Icon variant="PlayerSoccer" />}
      title={t('quickStart.savedSearchTitle')}
      description={
        <Trans
          t={t}
          i18nKey="quickStart.savedSearch"
          values={{ name: savedSearch.definition.titleSettings.title }}
          components={{ bold: <strong /> }}
        />
      }
      to={`/${locale}/data-locker/players?${searchParams}`}
    />
  );
};
